module.exports = __webpack_public_path__ + "static/media/atago-lose.fbe6762d.png";